import { TagsNetworkFilterGzDataProvider } from '../dataProvider/TagsNetworkFilterGzDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';

export class TagsNetworkFilterDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, TagsNetworkFilterGzDataProvider);
  }
}
